import react from "react";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import { Redirect, useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import logo from '../../../resources/img/logo-2.png';
import SelectorCiudad from "../custom/SelectorCiudad";
import SelectorPais from "../custom/SelectorPais";

function CuestionarioPaciente3() {
    
    const [direccion, setDireccion] = useState('');
    const [ciudad, setCiudad] = useState('');
    const [zona, setZona] = useState('');
    const [telefono, setTelefono] = useState('');
    const [celular, setCelular] = useState('');
    const [email, setEmail] = useState('');
    const [paisResidencia, setPaisResidencia] = useState('');
    const [idCiudad, setIdCiudad] = useState();
    const [idPaisResidencia, setIdPaisResidencia] = useState();

    const queryParams = useLocation().search;

    const [idPaciente, setIdPaciente] = useState(new URLSearchParams(queryParams).get('id'));
    const [emailPaciente, setEmailPaciente] = useState(new URLSearchParams(queryParams).get('email'));
    const [tokenPaciente, setTokenPaciente] = useState(new URLSearchParams(queryParams).get('token'));

    const [errorlist, setErrorlist] = useState({});
    const [loading, setLoading] = useState();
    
    // 🎯 ESTADO PARA ACORDEÓN REACT
    const [acordeonDomicilio, setAcordeonDomicilio] = useState(true);

    // variables para consulta de ciudad de residencia
    const [resultadosCiudades, setResultadosCiudades] = useState([]);
    const [resultadosCiudadesState, setResultadosCiudadesState] = useState('');
    const [deshabilitarInputCiudad, setDeshabilitarInputCiudad] = useState(false);
    const [btnEliminarCiudadVisible, setBtnEliminarCiudadVisible] = useState('hide');

    // variables para consulta de pais de residencia
    const [resultadosPaisResidencia, setResultadosPaisResidencia] = useState([]);
    const [resultadosPaisResidenciaState, setResultadosPaisResidenciaState] = useState('');
    const [deshabilitarInputPaisResidencia, setDeshabilitarInputPaisResidencia] = useState(false);
    const [btnEliminarPaisResidenciaVisible, setBtnEliminarPaisResidenciaVisible] = useState('hide');

    let history = useHistory();

    let userdata = [];

    useEffect(() => {

        const config = {
            params: {
                id: idPaciente
            }
        }

        axios.get('/paciente-publico',config)
            .then(response => {
                setDireccion(response.data[0].direccion);
                setCiudad(response.data[0].ciudad);
                setZona(response.data[0].zona);
                setTelefono(response.data[0].telefono);
                setEmail(response.data[0].email);
                setCelular(response.data[0].celular);

                setIdCiudad(response.data[0].id_ciudad_residencia);
                setCiudad(response.data[0].nombre_ciudad_residencia);

                setPaisResidencia(response.data[0].nombre_pais_residencia);
                setIdPaisResidencia(response.data[0].id_pais_residencia);

                if (response.data[0].id_pais_residencia!=null) {
                    setDeshabilitarInputPaisResidencia(true);
                    setBtnEliminarPaisResidenciaVisible('');
                }
                else {
                    setDeshabilitarInputPaisResidencia(false);
                    setBtnEliminarPaisResidenciaVisible('hide');
                }


                if (response.data[0].id_ciudad_residencia!=null) {
                    setDeshabilitarInputCiudad(true);
                    setBtnEliminarCiudadVisible('');
                }
                else {
                    setDeshabilitarInputCiudad(false);
                    setBtnEliminarCiudadVisible('hide');
                }
            })
            .catch(error => {
                console.log(error);
            })
    },[]);






    const agregarCiudad = (id,nombreCiudad,nombreDepto) => {

        // Se asigna el id de la ciudad
        setIdCiudad(id);
        // Se ocultan los resultados de la búsqueda
        setResultadosCiudadesState('');
        // Se llena el campo 'Ciudad'
        document.getElementById('ciudad').value = nombreCiudad+', '+nombreDepto;
        // Se deshabilita el campo 'Ciudad'
        setDeshabilitarInputCiudad(true);
        // Se muestra el botón para eliminar la selección de ciudad
        setBtnEliminarCiudadVisible('');
    }

    const eliminarCiudad = () => {
        
        setIdCiudad(null);
        document.getElementById('ciudad').value = '';
        setDeshabilitarInputCiudad(false);
        setBtnEliminarCiudadVisible('hide');
        document.getElementById('ciudad').focus();
    }

    const buscarCiudad = (e) => {

        if (e.length>2) {

            if (localStorage.getItem('userdata')) {
                userdata = JSON.parse(localStorage.getItem('userdata'));
            }
            
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    term: e
                }
            }
    
            axios.get('/ciudad',config)
                .then(response => {
    
                    if (response.status===200) {
                        
                        response.data.length>0 ? setResultadosCiudadesState('visible') : setResultadosCiudadesState('');
                        setResultadosCiudades(response.data);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                });
        }
    }







    const agregarPaisResidencia = (id,nombrePais) => {
        
        // Se asigna el id del pais de residencia
        setIdPaisResidencia(id);
        // Se ocultan los resultados de la búsqueda
        setResultadosPaisResidenciaState('');
        // Se llena el campo 'pasiResidencia'
        document.getElementById('paisResidencia').value = nombrePais;
        // Se deshabilita el campo 'paisResidencia'
        setDeshabilitarInputPaisResidencia(true);
        // Se muestra el botón para eliminar la selección de pais de residencia
        setBtnEliminarPaisResidenciaVisible('');
    }

    const eliminarPaisResidencia = () => {

        setIdPaisResidencia(null);
        document.getElementById('paisResidencia').value = '';
        setDeshabilitarInputPaisResidencia(false);
        setBtnEliminarPaisResidenciaVisible('hide');
        document.getElementById('paisResidencia').focus();
    }

    const buscarPaisResidencia = (e) => {

        if (e.length>2) {

            if (localStorage.getItem('userdata')) {
                userdata = JSON.parse(localStorage.getItem('userdata'));
            }
            
            const config = {
                headers: {
                    Authorization: 'Bearer ' + userdata.access_token
                },
                params: {
                    term: e
                }
            }
    
            axios.get('/pais',config)
                .then(response => {
    
                    if (response.status===200) {
                        
                        response.data.length>0 ? setResultadosPaisResidenciaState('visible') : setResultadosPaisResidenciaState('');
                        setResultadosPaisResidencia(response.data);
                    }
                })
                .catch(error => {
                    console.log(error.response);
                });
        }
    }









    const handleSubmit = (e) => {
        e.preventDefault();

        const config = {
            id:idPaciente,
            direccion: direccion,
            ciudad: idCiudad,
            zona: zona,
            telefono: telefono,
            celular: celular,
            email: email,
            pais_residencia: idPaisResidencia
        }

        axios.put('/datos-domicilio',config)
            .then(response => {
                setLoading(false);
                history.push({
                    pathname: '/cuestionario-paciente4',
                    search: '?id='+idPaciente
                });
            })
            .catch(error => {
                console.log(error.response.data);
                setErrorlist(error.response.data.errors);
            })
    }

    return (
            
                <div className="contenedor-cuestionario">

                    <div style={{textAlign:'center'}}>
                        <img src={logo} alt="logo smile" width="200" />
                    </div>

                    <div className="row mb-2" style={{marginTop:'30px'}}>
                        <h1 className="m-0" style={{textAlign: 'center', width: '100%'}}>Información personal</h1>
                    </div>

                    <div className="indicador-progreso">
                        <div className="indicador-punto completado">1</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">2</div>
                        <div className="indicador-linea completado"></div>
                        <div className="indicador-punto completado">3</div>
                        <div className="indicador-linea"></div>
                        <div className="indicador-punto">4</div>
                    </div>

                    <form id="quickForm" onSubmit={handleSubmit} autoComplete="off">
                        
                        <div className="card cuestionario-paciente">
                            <div className="card-header" onClick={() => setAcordeonDomicilio(!acordeonDomicilio)} style={{cursor: 'pointer'}}>
                                <h4 className="card-title w-100">
                                    <span className="d-block w-100" style={{textAlign:'center'}}>
                                        Información de Domicilio {acordeonDomicilio ? '▼' : '▶'}
                                    </span>
                                </h4>
                            </div>
                            <div id="infobasica" className={acordeonDomicilio ? 'show' : 'collapse'}>
                                <div className="card-body">

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="direccionPaciente">Dirección</label>
                                                <input type="text" name="direccion" className="form-control" id="direccionPaciente" value={direccion} onChange={(e) => setDireccion(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.direccion}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="ciudad">Ciudad</label>
                                                <SelectorCiudad 
                                                    value={idCiudad}
                                                    onChange={setIdCiudad}
                                                />
                                                <div className="invalid-feedback visible">
                                                {errorlist.ciudad}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="zonaDomicilio">Zona</label>
                                                <select name="zona-domicilio" className="form-control" id="zonaDomicilio" value={zona} onChange={(e) => setZona(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="urbano">URBANO</option>
                                                    <option value="rural">RURAL</option>
                                                </select>
                                                <div className="invalid-feedback visible">
                                                {errorlist.zona}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="paisResidencia">País</label>
                                                <SelectorPais 
                                                    value={idPaisResidencia}
                                                    onChange={setIdPaisResidencia}
                                                />
                                                <div className="invalid-feedback visible">
                                                {errorlist.pais_residencia}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="telefono">Teléfono</label>
                                                <input type="text" name="telefono" className="form-control" id="telefono" value={telefono} onChange={(e) => setTelefono(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.telefono}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="celular">Celular</label>
                                                <input type="text" name="celular" className="form-control" id="celular" value={celular} onChange={(e) => setCelular(e.target.value)}/>
                                                <div className="invalid-feedback visible">
                                                {errorlist.celular}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="email">Email</label>
                                                <input type="email" name="email" className="form-control" id="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                                            </div>
                                            <div className="invalid-feedback visible">
                                            {errorlist.email}
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <button type="submit" className="btn btn-primary" style={{margin: '0 auto', fontSize: '1.4rem'}}>
                                Continuar&nbsp;
                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                            </button>
                        </div>
                    </form>
                </div>
    );
}
export default CuestionarioPaciente3;